import { useEffect, useRef } from "react";

interface ClosingMessageProps {
  messageHeader: string
  messageTxt: string
}

export default function SurveyComplete({
  messageHeader,
  messageTxt,
}: ClosingMessageProps) {

  const completeRef = useRef<HTMLDivElement>(null);

  useEffect(()=>{
    completeRef.current?.focus();
  },[])


  return (
    <>
      <section className=" flex flex-col theme-survey-complete fade-in m-h-full" id="surveycomplete">
        <div tabIndex={0} ref={completeRef}> 
        <h1 className="text-5xl p-10 font-semibold text-center">{messageHeader}</h1>
        <div className="text-2xl text-center">{messageTxt}</div>
        </div>
      </section>
    </>
  )
}